import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import type { SubProduct } from '@atlassian/jira-common-constants/src/sub-product-types.tsx';

type SubProductProps = {
	subProduct: SubProduct;
	allowMonolithDeferral?: boolean;
};
type ProjectKeyProps = {
	projectType: ProjectType;
	allowMonolithDeferral?: boolean;
};

export type Props = SubProductProps | ProjectKeyProps;

export const isSubProductProps = (props: Props): props is Pick<SubProductProps, 'subProduct'> =>
	'subProduct' in props && typeof props.subProduct === 'string';
